import React from 'react'
import Navbar from '../../components/shared/Navbar/Navbar'
import Footer from '../../components/shared/Footer/Footer'
import ManuBanner from '../../components/pages/Manufacture/ManuBanner/ManuBanner'
import Capabilites from '../../components/pages/Manufacture/Capabilities/Capabilites'
import Complex from '../../components/pages/Manufacture/Complex/Complex'

const Manufacture = () => {
  return (
    <div>
        <Navbar />
        <ManuBanner/>
        <Capabilites/>
        <Complex/>
        <Footer/>
    </div>
  )
}

export default Manufacture